import * as React from "react";
import { Form, useFormApi, Option } from "informed";
import { TextBox } from "../../forms/informedv2/TextBox";
import { Required } from "../../forms/validation/Required";
import { Dropdown } from "../../forms/informedv2/Dropdown";
import { PopulationGroup, PredictedSet, CoreRace } from "webportalclient";
import { Checkbox } from "../../forms/informedv2/Checkbox";
import { nameof } from "ts-simple-nameof";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";

export interface PopulationGroupFormModel {
    Name: string;
    CoreRace: string;
    PredictedSet: string;
    CorrectionFactor: number;
}

export const PopulationGroupFormBody = () => {
    const client = useWebPortalApiClient();
    const [coreRaces, setCoreRaces] = React.useState<CoreRace[]>([]);
    const [predictedSets, setPredictedSets] = React.useState<PredictedSet[]>([]);

    React.useEffect(() => {
        const getData = async () => {
            const raceResult = await client.client.getRaces();

            setCoreRaces(raceResult.value);

            const predictedSetsResult = await client.client.getPredictedSets();
            setPredictedSets(predictedSetsResult.value);
        }

        getData();
    }, []);

    return (
        <>
            <div className="row">
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="select-site">Name</label>
                    <TextBox<string, PopulationGroupFormModel>
                        id={nameof<PopulationGroupFormModel>(f => f.Name)}
                        key={nameof<PopulationGroupFormModel>(f => f.Name)}
                        field={nameof<PopulationGroupFormModel>(f => f.Name)}
                        validate={Required}
                    />
                </div>
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="CoreRace">Core Race</label>
                    <Dropdown
                        id={nameof<PopulationGroupFormModel>(f => f.CoreRace)}
                        key={nameof<PopulationGroupFormModel>(f => f.CoreRace)}
                        field={nameof<PopulationGroupFormModel>(f => f.CoreRace)}
                        validate={Required}
                    >
                        <Option key="OptionBlank" value=""></Option>
                        {coreRaces.map(cr => (
                            <Option
                                key={`${cr.coreRaceKey}`}
                                value={cr.coreRaceKey}
                            >
                                {cr.name}
                            </Option>
                        ))}
                    </Dropdown>
                </div>
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="PredictedSet">Predicted Set</label>
                    <Dropdown
                        id={nameof<PopulationGroupFormModel>(f => f.PredictedSet)}
                        key={nameof<PopulationGroupFormModel>(f => f.PredictedSet)}
                        field={nameof<PopulationGroupFormModel>(f => f.PredictedSet)}
                        className="form-group col-md-4 col-sm-4 col-xs-12"
                        validate={Required}
                    >
                        <Option key="OptionBlank" value=""></Option>
                        {predictedSets.map(ps => (
                            <Option
                                key={`Option${ps.id}`}
                                value={ps.id}
                            >
                                {ps.name}
                            </Option>
                        ))}
                    </Dropdown>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="CorrectionFactor">Correction Factor</label>
                    <TextBox<number, PopulationGroupFormModel>
                        id={nameof<PopulationGroupFormModel>(f => f.CorrectionFactor)}
                        key={nameof<PopulationGroupFormModel>(f => f.CorrectionFactor)}
                        field={nameof<PopulationGroupFormModel>(f => f.CorrectionFactor)}
                        type="number"
                        validate={Required}
                    />
                </div>
                <div className="form-group col-md-4 col-sm-4 col-xs-12">
                    <label htmlFor="Disabled">Disabled</label>
                    <Checkbox
                        id="Disabled"
                        field="Disabled"
                        label="Disabled"
                    />
                </div>
            </div>
        </>
    );
}
